import { createEvent, restore } from 'effector';
import { EditorState } from 'draft-js';

// * events
export const setDescriptionEditorStateEvent = createEvent<EditorState>();

// * stores
export const $descriptionEditorState = restore<EditorState>(setDescriptionEditorStateEvent, EditorState.createEmpty());
